export default __webpack_public_path__ + "static/media/Visual 6.ecf7f29e.jpg";